import axios from 'axios';

import apiConstants from './constants/api-constants';
import Helpers from '../common/helpers';

class ClientsApi {
  static getClients(date_from, date_to, limit, page, reward_type) {
    const request = Helpers.formAxiosObject(apiConstants.request_methods.post, apiConstants.clients_routes.get_clients, { date_from, date_to, limit, page, reward_type });

    return axios(request);
  }
}

export default ClientsApi;



// WEBPACK FOOTER //
// ./src/api/clients-api.js